import {launchUpskill} from "../../upskill/utils/upskill.utils.js";

(() => {
    usePlatformNavFactory.$inject = ['$state', '$stateParams', '$filter', 'hUser', 'userPermissions', 'brandServices', 'barriAnalyticsService', 'harriSideBarService', 'hmapService', 'useDashboardsNavFactory', 'useTalentNavFactory', 'useWfmNavFactory', 'pmsGeneralSettingsService', 'useGPSettingsNav', 'useSettingsNav', 'useRecruitmentHubNav', 'localize', 'useEnterpriseReportsNav'];

    function usePlatformNavFactory($state, $stateParams, $filter, hUser, userPermissions, brandServices, barriAnalyticsService, harriSideBarService, hmapService, useDashboardsNavFactory, useTalentNavFactory, useWfmNavFactory, pmsGeneralSettingsService, useGPSettingsNav, useSettingsNav, useRecruitmentHubNav, localize, useEnterpriseReportsNav) {

        return function ($scope, hmapPath, isActiveLink, getBrandIds) {

            const {dashboardsNavItem} = useDashboardsNavFactory($scope, isActiveLink, getBrandIds);
            const {talentNav} = useTalentNavFactory($scope, isActiveLink, getBrandIds);
            const {wfmNav} = useWfmNavFactory($scope, isActiveLink, getBrandIds);
            const {gpSettingsNav} = useGPSettingsNav(hmapPath);
            const {settingsNav} = useSettingsNav($scope);
            const {recruitmentHubNav} = useRecruitmentHubNav($scope, getBrandIds);
            const {enterpriseReportsNav} = useEnterpriseReportsNav($scope, getBrandIds);

            const platformNav = [
                {
                    sections: [
                        {
                            items: [
                                {
                                    title: $filter('translate')('Launchpad'),
                                    redirectToWorkspace: true,
                                    icon: {
                                        unfilledSvg: '../images/svgs/dashboard.svg',
                                        filledSvg: '../images/svgs/dashboard_filled.svg'
                                    },
                                    isActive: () => isActiveLink('appLayout.harriSH.dashboard-tts'),
                                    href: () => $state.href('appLayout.harriSH.dashboard-tts'),
                                    isVisible: async () => {
                                        const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                        const brandIds = getBrandIds();
                                        const [
                                            policyParser,
                                            isTTSDashboardEnabled
                                        ] = await Promise.all([
                                            userPermissions.getBrandPolicy(activeBrandId),
                                            brandServices.check(brandServices.SERVICES.TTS_DASHBOARD, brandIds[0])
                                        ]);

                                        return (
                                            !hUser.isTopLevelContext() &&
                                            policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                            isTTSDashboardEnabled
                                        );
                                    },
                                    automation: 'SidebarLaunchpad'
                                },
                                {
                                    title: $filter('translate')('Talent acquisition'),
                                    automation: 'SidebarTalentAcquisition',
                                    icon: {
                                        unfilledSvg: '../images/svgs/talent.svg',
                                        filledSvg: '../images/svgs/talent_filled.svg'
                                    },
                                    subNav: talentNav,
                                    isVisible: talentNav[0].isVisible,
                                },
                                {
                                    title: $filter('translate')('Workforce management'),
                                    automation: 'SidebarWorkforceManagement',
                                    icon: {
                                        unfilledSvg: '../images/svgs/teamlive.svg',
                                        filledSvg: '../images/svgs/teamlive_filled.svg'
                                    },
                                    isVisible: wfmNav[0].isVisible,
                                    subNav: wfmNav
                                }
                            ]
                        }
                    ]
                },
                {
                    classNames: 'sb-main-items-container',
                    sections: [
                        {
                            classNames: 'flex-grow-1',
                            items: [
                                {
                                    title: $filter('translate')('My locations'),
                                    redirectToWorkspace: true,
                                    automation: 'SidebarMyLocations',
                                    icon: {
                                        unfilledSvg: '../images/svgs/location.svg',
                                        filledSvg: '../images/svgs/location.svg',
                                    },
                                    isActive: () => isActiveLink('appLayout.harriSH.access-portal.main', {hmapPath: ''}),
                                    href: () => '/access-portal/main',
                                    isVisible: async () => {
                                        return hUser.isHMAPUser();
                                    },
                                },
                                {
                                    title: $filter('translate')('Enterprise dashboards'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                        filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                    },
                                    subNav: dashboardsNavItem,
                                    isVisible: dashboardsNavItem[0].isVisible,
                                    automation: 'EnterpriseDashboardsIconButton'
                                },
                                {
                                    title: $filter('translate')('Recruitment hub'),
                                    icon: {
                                        unfilledSvg: '../hui/modules/svg/recruitment-hub.svg',
                                        filledSvg: '../hui/modules/svg/recruitment-hub-filled.svg'
                                    },
                                    isVisible: recruitmentHubNav[0].isVisible,
                                    subNav: recruitmentHubNav,
                                    automation: 'MyJobsIconButton'
                                },
                                {
                                    title: $filter('translate')('Documents'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/my_docs.svg',
                                        filledSvg: '../images/svgs/my_docs_filled.svg'
                                    },
                                    automation: 'MyJobsIconButton',
                                    isActive: () => isActiveLink('appLayout.harriSH.docs'),
                                    href: () => $state.href('appLayout.harriSH.docs'),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        const [
                                            policyParser,
                                            isOnboardingEnabled,
                                            isOnboardingJourneyEnabled,
                                        ] = await Promise.all([
                                            userPermissions.getBrandPolicy(brandIds),
                                            brandServices.check(brandServices.SERVICES.ON_BOARDING, brandIds[0], true),
                                            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                                        ]);

                                        return (
                                            isOnboardingEnabled &&
                                            policyParser.brands(policyParser.ANY).hasAny(userPermissions.VIEW_ONBOARDING) &&
                                            policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                            !isOnboardingJourneyEnabled
                                        );
                                    },
                                },
                                {
                                    title: $filter('translate')('Talent pool'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/talent_pool.svg',
                                        filledSvg: '../images/svgs/talent_pool_filled.svg'
                                    },
                                    automation: 'TalentPoolIconButton',
                                    isActive: () => isActiveLink('appLayout.harriSH.talent-pool'),
                                    redirectToWorkspace: true,
                                    href: () => {
                                        const brandId = (hUser.isTopLevelContext() && $state.current.name !== 'appLayout.harriSH.talent-pool')
                                            ? hmapService.getActiveBrand()
                                            : hUser.getUserContext().brand_id;

                                        return $state.href('appLayout.harriSH.talent-pool', {brandId});
                                    },
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();

                                        const checkIfGTPServiceEnabled = async () => {
                                            let isGTPServiceEnabled = false;
                                            const hmapActiveBrandId = hmapService.getActiveBrand();
                                            const gpPolicy = await hmapService.loadGPPlociy(hmapActiveBrandId);

                                            if (gpPolicy) {
                                                const activeBrandPolicy = gpPolicy.brands.find((entry) => {
                                                    return entry.id === hmapActiveBrandId;
                                                });

                                                if (activeBrandPolicy) {
                                                    for (let service in activeBrandPolicy.services) {
                                                        if (activeBrandPolicy.services[service]?.code === brandServices.SERVICES.GLOBAL_TALENT_POOL) {
                                                            isGTPServiceEnabled = true;
                                                        }
                                                    }
                                                }
                                            }

                                            return isGTPServiceEnabled;
                                        }

                                        return Promise.all([
                                            userPermissions.getBrandPolicy(brandIds),
                                            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                                            harriSideBarService.checkGlobalTalentPoolPermission(),
                                            checkIfGTPServiceEnabled()
                                        ]).then(([
                                                     policyParser,
                                                     isOnboardingJourneyEnabled,
                                                     hasManageTalentPoolPermission,
                                                     isGTPServiceEnabled
                                                 ]) => (
                                            policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                            !isOnboardingJourneyEnabled &&
                                            hasManageTalentPoolPermission &&
                                            (!hUser.isTopLevelContext() || isGTPServiceEnabled)
                                        ));
                                    }
                                },
                                {
                                    title: $filter('translate')('Enterprise reports'),
                                    isActive: () => isActiveLink(`appLayout.harriSH.reporting`),
                                    icon: {
                                        unfilledSvg: '../images/svgs/report.svg',
                                        filledSvg: '../images/svgs/report_filled.svg',
                                    },
                                    subNav: enterpriseReportsNav,
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        const policyParser = await userPermissions.getBrandPolicy(brandIds);
                                        return hUser.hasSalesAccess() && policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)
                                    },
                                    automation: 'EnterpriseReportsIconButton'
                                },
                                {
                                    title: $filter('translate')('Harri iQ'),
                                    icon: {
                                        unfilledSvg: `../images/svgs/harriIQ.svg`,
                                        filledSvg: `../images/svgs/harriIQ_filled.svg`
                                    },
                                    automation: 'HarriIQIconButton',
                                    isActive: () => isActiveLink('appLayout.harriSH.harri-iq'),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        const isBarriEnabled = await brandServices.check(brandServices.SERVICES.ANALYTICS_BARRI, brandIds[0], true);
                                        const allowedBarriRoutes = isBarriEnabled
                                            ? await barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id)
                                            : [];

                                        return allowedBarriRoutes?.length > 0;
                                    },
                                    dropdownOpen: false,
                                    subItems: [
                                        {
                                            title: $filter('translate')('Home'),
                                            href: () => $state.href('appLayout.harriSH.harri-iq', {route: 'home'}),
                                            isVisible: async () => {
                                                const brandIds = getBrandIds();
                                                const allowedBarriRoutes = await barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id);
                                                return allowedBarriRoutes.indexOf('home') > -1;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('My liveboards'),
                                            href: () => $state.href('appLayout.harriSH.harri-iq', {route: 'liveboards'}),
                                            isVisible: async () => {
                                                const brandIds = getBrandIds();
                                                const allowedBarriRoutes = await barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id);
                                                return allowedBarriRoutes.indexOf('liveboards') > -1;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('Search data'),
                                            href: () => $state.href('appLayout.harriSH.harri-iq', {route: 'search'}),
                                            isVisible: async () => {
                                                const brandIds = getBrandIds();
                                                const allowedBarriRoutes = await barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id);
                                                return allowedBarriRoutes.indexOf('search') > -1;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('My Spot IQ results'),
                                            href: () => $state.href('appLayout.harriSH.harri-iq', {route: 'spot-iq'}),
                                            isVisible: async () => {
                                                const brandIds = getBrandIds();
                                                const allowedBarriRoutes = await barriAnalyticsService.getUserBarriAllowedRoutes(brandIds[0], hUser.data.user.id);
                                                return allowedBarriRoutes.indexOf('spot-iq') > -1;
                                            }
                                        },
                                    ],
                                },
                                {
                                    title: $filter('translate')('CommsHub'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/commshub.svg',
                                        filledSvg: '../images/svgs/commshub.svg',
                                    },
                                    automation: 'HeaderAccessCommsHubButton',
                                    badgeContent: '',
                                    getBadgeContent: async () => {
                                        return TeamCommunicationAPI.getUnreadMessagesCount();
                                    },
                                    isActive: () => isActiveLink('appLayout.harriSH.communication-hub.message'),
                                    href: () => $state.href('appLayout.harriSH.communication-hub.message'),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        return await brandServices.check(brandServices.SERVICES.ENTERPRISE_COMMUNICATION, brandIds[0], true);
                                    },
                                },
                                {
                                    title: $filter('translate')('CoreHR'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/coreHR.svg',
                                        filledSvg: '../images/svgs/coreHR.svg',
                                    },
                                    automation: 'LaunchCoreHR',
                                    isActive: () => isActiveLink(`appLayout.harriSH.core-hr.list`),
                                    href: () => $state.href(`appLayout.harriSH.core-hr.list`),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        const brandIdWithAccess = hUser.getActiveBrandIdWithAccess();

                                        const [
                                            isCoreHRServiceEnabled,
                                            isTeamSchedulingEnabled,
                                            policyParser
                                        ] = await Promise.all([
                                            brandServices.check(brandServices.SERVICES.CORE_HR, hUser.getEntryMode().brand_id, true),
                                            brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getEntryMode().brand_id, true),
                                            userPermissions.getBrandPolicy(brandIds)
                                        ]);

                                        const hasAccessToTeam = policyParser.brands(brandIdWithAccess[0]).hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                                        return (isCoreHRServiceEnabled || isTeamSchedulingEnabled) && hasAccessToTeam;
                                    },
                                },
                                {
                                    title: $filter('translate')('ADAM'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/adam.svg'
                                    },
                                    automation: 'LaunchADAM',
                                    isActive: () => isActiveLink('appLayout.harriSH.adam.views'),
                                    href: () => $state.href('appLayout.harriSH.adam.views'),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        const [
                                            isADAMServiceEnabled,
                                            policyParser
                                        ] = await Promise.all([
                                            brandServices.check(brandServices.SERVICES.ADAM, hUser.getEntryMode().brand_id, true),
                                            userPermissions.getBrandPolicy(brandIds)
                                        ]);

                                        return (
                                            isADAMServiceEnabled &&
                                            policyParser.has(userPermissions.PERMISSIONS.MANAGE_ADAM) &&
                                            (
                                                policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) ||
                                                hUser.isHMAPUser()
                                            )
                                        );
                                    },
                                },
                                {
                                    title: $filter('translate')('Performance management'),
                                    icon: {unfilledSvg: '../images/svgs/pms_filled.svg'},
                                    isActive: () => isActiveLink('appLayout.harriSH.pms'),
                                    href: () => {
                                        let brandId;

                                        if (hUser.isTopLevelContext()) {
                                            brandId = hmapService.getActiveBrand();
                                        } else {
                                            brandId = hUser.getUserContext().brand_id;
                                        }
                                        return $state.href('appLayout.harriSH.pms.questions-and-templates', { brand_id: brandId });
                                    },
                                    automation: 'PerformanceIconButton',
                                    isVisible: async () => {
                                        const canViewPms = async () => {
                                            let activeBrandType;

                                            if (hUser.isTopLevelContext()) {
                                                const activeBrandId = hmapService.getActiveBrand();
                                                const hmapBrandInfo = await hmapService.loadBrandDetails(activeBrandId);
                                                activeBrandType = hmapBrandInfo?.type;
                                            } else {
                                                activeBrandType = hUser.getUserContext().brand_type;
                                            }

                                            const manageLevelPMS = await pmsGeneralSettingsService.checkManagementLevel(activeBrandType);
                                            return manageLevelPMS.canAccessSameAndBelowLevel;
                                        };

                                        const brandIds = getBrandIds();
                                        const [
                                            isPMSEnabled,
                                            policyParser
                                        ] = await Promise.all([
                                            brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, brandIds[0], true),
                                            userPermissions.getBrandPolicy(brandIds),
                                        ]);

                                        return (
                                            isPMSEnabled &&
                                            await canViewPms() &&
                                            (
                                                policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) ||
                                                hUser.isHMAPUser()
                                            )
                                        );
                                    },
                                },
                                {
                                    title: $filter('translate')('Enterprise logbook'),
                                    isActive: () => isActiveLink('appLayout.harriSH.enterprise-logbook'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/enterprise-logbook.svg',
                                        filledSvg: '../images/svgs/enterprise-logbook-filled.svg'
                                    },
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();
                                        let showEntriesSubMenuItem, showTasksSubMenuItem, showMyTasksSubMenuItem, showChecklistsSubMenuItem;
                                        const isLogbookServiceEnabled = await brandServices.check(brandServices.SERVICES.LOGBOOK, brandIds[0], true);

                                        if (isLogbookServiceEnabled) {
                                            const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                            const [
                                                logbookActions,
                                                employeeBrands
                                            ] = await Promise.all([
                                                LogbookAPI.getLogbookActions(activeBrandId),
                                                TeamAPI.getEmployeeLocations(activeBrandId)
                                            ]);

                                            showEntriesSubMenuItem = logbookActions?.view_entries;
                                            showChecklistsSubMenuItem = logbookActions?.manage_checklists;
                                            showTasksSubMenuItem = logbookActions?.manage_tasks;

                                            let logbookBrands = employeeBrands.filter((brand) => brand.services.includes(brandServices.SERVICES.LOGBOOK));
                                            showMyTasksSubMenuItem = logbookBrands.length > 0;
                                        }

                                        return (
                                            hUser.isTopLevelContext() &&
                                            (
                                                isLogbookServiceEnabled && (
                                                    showEntriesSubMenuItem ||
                                                    showTasksSubMenuItem ||
                                                    showMyTasksSubMenuItem ||
                                                    showChecklistsSubMenuItem
                                                ))
                                        );
                                    },
                                    dropdownOpen: false,
                                    subItems: [
                                        {
                                            title: $filter('translate')('Entries'),
                                            isActive: () => isActiveLink('appLayout.harriSH.enterprise-logbook.entries'),
                                            href: () => $state.href('appLayout.harriSH.enterprise-logbook.entries'),
                                            isVisible: async () => {
                                                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                                const logbookActions = await LogbookAPI.getLogbookActions(activeBrandId);
                                                return logbookActions?.view_entries;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('Checklists'),
                                            isActive: () => isActiveLink('appLayout.harriSH.enterprise-logbook.checklists'),
                                            href: () => $state.href('appLayout.harriSH.enterprise-logbook.checklists'),
                                            isVisible: async () => {
                                                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                                const logbookActions = await LogbookAPI.getLogbookActions(activeBrandId);
                                                return logbookActions?.manage_checklists;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('My tasks'),
                                            isActive: () => $state.is('appLayout.harriSH.enterprise-logbook.tasks', {"my-tasks": true}),
                                            href: () => $state.href('appLayout.harriSH.enterprise-logbook.tasks', {'my-tasks': true}),
                                            isVisible: async () => {
                                                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                                const employeeBrands = await TeamAPI.getEmployeeLocations(activeBrandId) ?? [];
                                                let logbookBrands = employeeBrands.filter((brand) => brand.services.includes(brandServices.SERVICES.LOGBOOK));
                                                return logbookBrands.length > 0;
                                            }
                                        },
                                        {
                                            title: $filter('translate')('Tasks'),
                                            isActive: () => $state.is('appLayout.harriSH.enterprise-logbook.tasks', {"my-tasks": false}),
                                            href: () => $state.href('appLayout.harriSH.enterprise-logbook.tasks', {'my-tasks': false}),
                                            isVisible: async () => {
                                                const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                                const logbookActions = await LogbookAPI.getLogbookActions(activeBrandId);
                                                return logbookActions?.manage_tasks;
                                            }
                                        }
                                    ]
                                },
                                {
                                    title: $filter('translate')('Training management'),
                                    icon: {
                                        unfilledSvg: '../hui/modules/svg/outlined-elearning-settings.svg'
                                    },
                                    automation: 'LMSAccessTrainingButton',
                                    isActive: () => isActiveLink('lms.lms-employer-dashboard'),
                                    href: () => $state.href('lms.lms-employer-dashboard'),
                                    isVisible: async () => {
                                        const isLMSServiceEnabled = await brandServices.check(brandServices.SERVICES.LMS, hUser.getEntryMode().brand_id);
                                        return hUser.isTopLevelContext() && hUser.isHMAPUser() && isLMSServiceEnabled;
                                    }

                                },
                                {
                                    title: $filter('translate')('Training management'),
                                    icon: {
                                        unfilledSvg: '../hui/modules/svg/outlined-elearning-settings.svg'
                                    },
                                    onClick: async () => {
                                        const brandId = hUser.isTopLevelContext() ? hmapService.getActiveBrand() : hUser.getUserContext().brand_id;
                                        const params = {
                                            lang: localize.getLang()
                                        }
                                        launchUpskill(brandId, params);
                                    },
                                    isVisible: async () => {
                                        const brandId = hUser.isTopLevelContext() ? hmapService.getActiveBrand() : hUser.getUserContext().brand_id;
                                        const brandInfo = await hmapService.loadBrandDetails(brandId);
                                        if (!brandInfo.financial_unit_brand_id) {
                                            return false;
                                        }
                                        return await brandServices.check(brandServices.SERVICES.UPSKILL, brandInfo.financial_unit_brand_id);
                                    }
                                },
                                {
                                    title: $filter('translate')('Academy management'),
                                    icon: {
                                        unfilledSvg: '../hui/modules/svg/outlined-academy-settings.svg'
                                    },
                                    automation: 'LMSAccessTrainingButton',
                                    isActive: () => isActiveLink('elearning-northpass.elearning-northpass-manager-dashboard-learners'),
                                    href: () => $state.href('elearning-northpass.elearning-northpass-manager-dashboard-learners'),
                                    isVisible: async () => {
                                        const brandIds = getBrandIds();

                                        const [
                                            isLMSELearningServiceEnabled,
                                            policyParser
                                        ] = await Promise.all([
                                            brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id),
                                            userPermissions.getBrandPolicy(brandIds)
                                        ])

                                        const hasManageAdminsTraining = policyParser.has(userPermissions.LMS['MANAGE_ADMIN_TRAINING']);
                                        return (
                                            hUser.isTopLevelContext() &&
                                            hUser.isHMAPUser() &&
                                            isLMSELearningServiceEnabled &&
                                            hasManageAdminsTraining
                                        );
                                    }

                                },
                                {
                                    title: $filter('translate')('Settings'),
                                    automation: 'SideMenuSettingsButton',
                                    icon: {
                                        unfilledSvg: '../images/svgs/settings.svg',
                                        filledSvg: '../images/svgs/settings_filled.svg'
                                    },
                                    isVisible: gpSettingsNav[0].isVisible,
                                    subNav: gpSettingsNav
                                },
                                {
                                    title: $filter('translate')('Settings'),
                                    icon: {
                                        unfilledSvg: '../images/svgs/settings.svg',
                                        filledSvg: '../images/svgs/settings_filled.svg'
                                    },
                                    isVisible: settingsNav[0].isVisible,
                                    subNav: settingsNav
                                },
                            ]
                        }
                    ]
                }
            ];

            return {
                platformNav
            }
        }
    }

    angular
        .module("harriApp")
        .factory('usePlatformNavFactory', usePlatformNavFactory);
})();